<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$teal-bg:   #e4f3f0;
$dark:      #1a1a2e;
$gray:      #6c7280;
$font:      'Segoe UI', system-ui, sans-serif;

.disc-wrap {
  background: $teal-bg !important;
  min-height: 100vh;
  font-family: $font;
}

.disc-page-container {
  padding-top: 24px;
  padding-bottom: 90px;

  @media (min-width: 768px)  { padding-top: 32px; }
  @media (min-width: 1024px) { padding-top: 40px; max-width: 860px; margin: 0 auto; }
}

.disc-heading {
  margin-bottom: 20px;

  &__title {
    font-size: 20px;
    font-weight: 700;
    color: $teal-dark;
    margin: 0 0 6px;

    @media (min-width: 768px) { font-size: 24px; }
  }

  &__sub {
    font-size: 13px;
    color: $gray;
    margin: 0;
  }
}

/* Citizenship route heading */
.citizenship-heading {
  text-align: center;
  margin-bottom: 20px;

  h1 {
    font-size: 22px;
    font-weight: 700;
    color: $teal-dark;
    margin: 0 0 6px;

    @media (min-width: 768px) { font-size: 28px; }
  }

  p {
    font-size: 13px;
    color: $gray;
    margin: 0;
  }
}

.font-bold { font-weight: bold; }
</style>

<template>
  <section class="disc-wrap content d-flex flex-column flex-column-fluid">
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid disc-page-container">

        <!-- Disclosure route heading -->
        <div class="disc-heading" v-if="routeName == 'client.appointment.disclosure'">
          <h2 class="disc-heading__title">Disclosure Agreement</h2>
          <p class="disc-heading__sub">Please read and accept the following terms before continuing.</p>
        </div>

        <!-- Citizenship route heading -->
        <div class="citizenship-heading" v-if="routeName == 'client.appointment.citizenship'">
          <h1>FBI BACKGROUND CHECK{{ getAttorneyRequest ? ' - ATTORNEY REQUEST' : '' }}</h1>
          <p v-if="step == 1">Citizenship Requirements</p>
        </div>

        <div class="row">
          <div class="col-12">
            <v-citizen
              v-if="step == 1 && routeName == 'client.appointment.citizenship'"
            ></v-citizen>
            <v-disclaimer
              v-if="step == 2 && routeName == 'client.appointment.citizenship'"
              v-on:term="tiggerTerm"
            ></v-disclaimer>

            <v-f-disclaimer
              v-if="step == 1 && routeName == 'client.appointment.disclosure'"
              v-on:term="tiggerTerm"
            ></v-f-disclaimer>
          </div>
        </div>

      </div>
      <v-foooter
        v-on:next="nextStep"
        v-on:back="back"
        :btnname="'Next'"
        :backname="'Back'"
      ></v-foooter>
    </div>
  </section>
</template>

<script>
import vFoooter from "./foooter.vue";
import vCitizen from "./status.vue";
import vDisclaimer from "./disclaimer.vue";
import vFDisclaimer from "./fndisclamier.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    vFoooter,
    vCitizen,
    vDisclaimer,
    "v-f-disclaimer": vFDisclaimer
  },
  data() {
    return {
      step: 1,
      check1: false,
      routeName: ""
    };
  },
  computed: {
    ...mapGetters(["getServiceId", "getfServiceSlug", "getBiometricDataCollectionDisclosure", "getAttorneyRequest"])
  },
  created() {
    this.routeName = this.$route.name;

    if (this.getServiceId == 0) {
      // this.$toastr.e("You have not select service");
      this.$router.push({
        name: "frontend.home",
        params: { slug: this.$route.params.client_slug }
      });
    }
  },
  methods: {
    tiggerTerm(flag) {
      this.check1 = flag;
    },
    back() {
      if (this.step == 1) {
        var client_slug = this.$route.params.client_slug;
        var id = this.$route.params.id;
        if(this.getBiometricDataCollectionDisclosure){
          this.$router.push({
            name: "client.appointment.biometric-disclosure",
            params: { id: id, client_slug: client_slug },
          });
        } else if (this.getAttorneyRequest) {
          this.$router.push({
            name: "client.appointment.request-letter",
            params: { id: id, client_slug: client_slug },
          });
        } else{
          this.$router.push({
            name: "frontend.agent.locations",
            params: { slug: this.getfServiceSlug }
          });
        }
      } else if (this.step == 2) {
        this.step = 1;
      }
    },
    nextStep() {
      if (this.step == 1) {
        if (this.routeName == "client.appointment.citizenship") {
          this.step = 2;
        } else {
          if (this.check1) {
            var id_ = this.$route.params.id;
            this.$router.push({
              name: "frontend.booknow",
              params: { id: id_ }
            });
          } else {
            this.$toastr.e("Plase accept both terms and conditions");
          }
        }
      } else if (this.step == 2) {
        if (this.check1) {
          var id = this.$route.params.id;
          this.$router.push({ name: "frontend.booknow", params: { id: id } });
        } else {
          this.$toastr.e("Plase accept both terms and conditions");
        }
      }
    }
  }
};
</script>
